import token from 'utils/token';
import { authExchange } from '@urql/exchange-auth';
import {
  createClient, dedupExchange, cacheExchange, fetchExchange,
} from 'urql';
import { makeOperation } from '@urql/core';

const { NEXT_PUBLIC_SCVR_ROOT } = process.env;

const getAuth = async () => null;
const willAuthError = () => !token.isValid;

const addAuthToOperation = ({ operation }) => {
  if (!token.isValid) return operation;

  // fetchOptions can be a function (See Client API) but you can simplify this based on usage
  const fetchOptions = typeof operation.context.fetchOptions === 'function'
    ? operation.context.fetchOptions()
    : operation.context.fetchOptions || {};

  const op = makeOperation(operation.kind, operation, {
    ...operation.context,
    fetchOptions: {
      ...fetchOptions,
      headers: {
        ...fetchOptions.headers,
        Authorization: `Bearer ${token}`,
      },
    },
  });

  return op;
};

const client = createClient({
  url: `${NEXT_PUBLIC_SCVR_ROOT}/graphql`,
  requestPolicy: 'network-only',
  exchanges: [
    dedupExchange,
    cacheExchange,
    authExchange({
      getAuth,
      addAuthToOperation,
      willAuthError,
    }),
    fetchExchange,
  ],
});

export default client;
